import { CallStatus } from '../typings';
import { ReactComponent as CallIncomingIcon } from '../../../shared/assets/svg/call-incoming.svg';
import { ReactComponent as CallMissedIcon } from '../../../shared/assets/svg/call-missed.svg';

export const getCallIConsAndStyles = (status: CallStatus, size = 16) => {
  let styles = {
    bg: '#ffffff',
    titleColor: '#2d2d2d',
    iconColor: '#3D906D',
    icon: <CallIncomingIcon width={size} height={size} />,
    label: 'Unknown status',
    wabaLabelColor: '#2d2d2d',
    wabaNumberColor: '#9B9B9B',
  };
  switch (status) {
    case CallStatus.INITIATED:
      styles = {
        bg: '#F0F5F0',
        titleColor: '#3D906D',
        iconColor: '#3D906D',
        icon: <CallIncomingIcon width={size} height={size} />,
        label: 'Incoming call',
        wabaLabelColor: '#2d2d2d',
        wabaNumberColor: '#9B9B9B',
      };
      break;
    case CallStatus.Connecting:
      styles = {
        bg: '#3D906D',
        titleColor: '#ffffffb3',
        iconColor: '#ffffff',
        icon: <CallIncomingIcon width={size} height={size} />,
        label: 'Connecting...',
        wabaLabelColor: '#fff',
        wabaNumberColor: '#ffffffb3',
      };
      break;
    case CallStatus.IN_PROGRESS:
      styles = {
        bg: '#3D906D',
        titleColor: '#ffffffb3',
        iconColor: '#ffffff',
        icon: <CallIncomingIcon width={size} height={size} />,
        label: 'Ongoing call',
        wabaLabelColor: '#fff',
        wabaNumberColor: '#ffffffb3',
      };
      break;
    case CallStatus.END:
      styles = {
        bg: '#ffffff',
        titleColor: '#2d2d2d',
        iconColor: '#3D906D',
        icon: <CallIncomingIcon width={size} height={size} />,
        label: 'Call ended',
        wabaLabelColor: '#2d2d2d',
        wabaNumberColor: '#9B9B9B',
      };
      break;
    case CallStatus.MISSED:
      styles = {
        bg: '#FDF7F7',
        titleColor: '#EF5350',
        iconColor: '#EF5350',
        icon: <CallMissedIcon width={size} height={size} />,
        label: 'Missed call',
        wabaLabelColor: '#2d2d2d',
        wabaNumberColor: '#9B9B9B',
      };
      break;
    default:
      styles = {
        bg: '#ffffff',
        titleColor: '#2d2d2d',
        iconColor: '#3D906D',
        icon: <CallIncomingIcon width={size} height={size} />,
        label: 'Unknown status',
        wabaLabelColor: '#2d2d2d',
        wabaNumberColor: '#9B9B9B',
      };
      break;
  }
  return styles;
};
